import React, {PureComponent} from 'react';
import { Input }from 'reactstrap';
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";

import { loadComponentsByPage } from "../../../redux/actions/componentActions";
import { loadAssetTypes } from "../../../redux/actions/entity_types";
import {connect} from "react-redux";
import appConfig from "../../../config/constants";

class ComponentFilter extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isAllFilter: false,
            asset_name: '',
            aggregate_severity: '',
        };
    }

    componentDidMount() {
        const { assetsHealthFilterFieldData, loadAssetTypes } = this.props;
        const asset_name =
          assetsHealthFilterFieldData && assetsHealthFilterFieldData.length > 0
            ? assetsHealthFilterFieldData.split('=')[1] : '';
        this.setState({ asset_name });

        loadAssetTypes();
    }

    componentWillReceiveProps(props){
        const isUpdatedProps = props.resetComponentFilterField  !== this.props.resetComponentFilterField;
        if (isUpdatedProps && props.resetComponentFilterField ==='resetAll') {
            this.resetAllChangeHandler();
        } else if(props.resetComponentFilterField  && isUpdatedProps ) {
            this.resetChangeHandler(props.resetComponentFilterField )
        }
    }

    resetChangeHandler = (label) => {
        this.setState({
            [label]: ''
        }, this.getFilteredData);
    };

    resetAllChangeHandler = () => {
        this.setState( {...this.initialState} , this.getFilteredData);
    };

    handleAllFilter = () => {
        const { isAllFilter } = this.state;
        this.setState({ isAllFilter: !isAllFilter })
    };

    getFilteredData = () => {
        const {
            review_status,
            collection_name,
            asset_name,
            aggregate_status,
            asset_type_name,
            component_name,
            aggregate_severity,
        } = this.state;
        const { sortBy } = this.props;

        let filterFieldData =
          (review_status && review_status.length > 0 ? `&review_status=${review_status}`: '') +
          (collection_name && collection_name.length > 0 ? `&collection_name=${collection_name}`: '') +
          (asset_name && asset_name.length > 0 ? `&asset_name=${asset_name}`: '') +
          (aggregate_status && aggregate_status.length > 0 ? `&aggregate_status=${aggregate_status}`: '') +
          (asset_type_name && asset_type_name.length > 0 ? `&asset_type_name=${asset_type_name}`: '') +
          (aggregate_severity && aggregate_severity.length > 0 ? `&aggregate_severity=${aggregate_severity}`: '') +
          (component_name && component_name.length > 0 ? `&component_name=${component_name}`: '');

        this.props.loadComponentsByPage({
            page: 1,
            perPage: 20,
            filterFieldData,
            sortBy,
        });
    };

    changeHandler = (label, e) => {
        this.setState({
            [label]: e.target.value
        }, this.getFilteredData);
    };

    handleRadioBtnClick = aggregate_severity => this.setState({ aggregate_severity }, this.getFilteredData);

    hiddenFilter = () => {
        const { isAllFilter, aggregate_severity } = this.state;
        const { t, asset_types } = this.props;
        if(isAllFilter) {
            return (
                <div className={`pro hide text-center severity hidden-filter-div`}>
                    <div className="normal-width-two text-left">
                        <h6>{t('asset_health.asset_labels.severity')} :
                            <label>
                                <input
                                  type="radio"
                                  name="aggregate_severity"
                                  onChange={() => {this.handleRadioBtnClick('critical')}}
                                  checked={aggregate_severity === 'critical'}
                                />
                                {t('asset_events.asset_labels.severityList.critical')}
                            </label>
                            <label>
                                <input
                                  type="radio"
                                  name="aggregate_severity"
                                  onChange={() => {this.handleRadioBtnClick('minor')}}
                                  checked={aggregate_severity === 'minor'}
                                />
                                {t('asset_events.asset_labels.severityList.minor')}
                            </label>
                            <label>
                                <input
                                  type="radio"
                                  name="aggregate_severity"
                                  onChange={() => {this.handleRadioBtnClick('major')}}
                                  checked={aggregate_severity === 'major'}
                                />
                                {t('asset_events.asset_labels.severityList.major')}
                            </label>
                            <label>
                                <input
                                  type="radio"
                                  name="aggregate_severity"
                                  onChange={() => {this.handleRadioBtnClick('normal')}}
                                  checked={aggregate_severity === 'normal'}
                                />
                                {t('asset_events.asset_labels.severityList.normal')}
                            </label>
                        </h6>
                    </div>
                    {appConfig.APP == "ANOMALY"? "":
                    <div className="normal-width sm-top">
                        <Input
                          type="select" bsSize="sm"
                          onChange={e => this.changeHandler('aggregate_status', e)}
                        >
                            <option value=''>{t('asset_health.asset_labels.health_status')}</option>
                            <option value="HEALTHY">Healthy</option>
                            <option value="FAULTY">Faulty</option>
                            <option value="ANOMALOUS">Anomalous</option>
                            <option value="DEGRADING">Degrading</option>
                            <option value="LOW_RUL">Low RUL</option>
                            <option value="VERY_LOW_RUL">Very Low RUL</option>
                            <option value="IMPENDING_FAILURE">Impending Failure</option>
                            <option value="MULTIPLE_ISSUES">Multiple Issues</option>
                        </Input>
                    </div>
                    }
                    <div className="normal-width  sm-top">
                        <Input
                          type="select" bsSize="sm"
                          onChange={e => this.changeHandler('asset_type_name', e)}
                        >
                            <option value=''>{t('asset_health.asset_labels.action_status')}</option>
                            {
                                asset_types && asset_types.length > 0 &&
                                asset_types.map( (assetType, assetTypeIndex) =>
                                  <option key={ assetTypeIndex } value={ assetType.name }>
                                      { assetType.name }
                                  </option>
                                )
                            }
                        </Input>
                    </div>
                </div>
            )
        }
    };

    render() {
        const { isAllFilter, asset_name } = this.state;
        const { t } = this.props;
        return(
            <div className="col-lg-12 col-xs-12 col-sm-12  field full-width">
            <div className="col-lg-12 col-xs-12 col-sm-12 padding-none">
                <div className="white-bg">
                    <div className="title-details">
                        <div className="col-lg-12 col-sm-12 col-xs-12">
                            <h4>{t('asset_health.sub_title')}</h4>
                        </div>
                    </div>
                    <div className="pro text-center justify">
                        <div className="normal-width">
                            <a
                              className={`filterbtn ${isAllFilter && 'active'}`}
                              onClick={() => this.handleAllFilter()}
                            >
                                {t('asset_health.asset_labels.all_filters')}
                            </a>
                        </div>
                        <div className="normal-width">
                            <Input
                              type="select"
                              bsSize="sm"
                              onChange={e => this.changeHandler('review_status', e)}
                            >
                                <option value=''>{t('asset_health.asset_labels.action_status')}</option>
                                <option value='PENDING'>Pending</option>
                                <option value='REVIEWED'>Reviewed</option>
                            </Input>
                        </div>
                        <div className="normal-width">
                            <input
                              type="search"
                              placeholder={t('asset_health.asset_labels.collection') + '...'}
                              onChange={e => this.changeHandler('collection_name', e)}
                            />
                        </div>
                        <div className="normal-width">
                            <input
                              type="search"
                              placeholder={t('asset_health.asset_labels.asset') + '...'}
                              onChange={e => this.changeHandler('asset_name', e)}
                              value={asset_name}
                            />
                        </div>
                        <div className="normal-width  sm-top">
                            <input
                              type="search"
                              placeholder={t('asset_health.asset_labels.component') + '...'}
                              onChange={e => this.changeHandler('component_name', e)}
                            />
                        </div>
                    </div>
                    {this.hiddenFilter()}
                </div>
            </div>
        </div>);
    }
}

function mapStateToProps({asset_types, component}) {
    return {
        asset_types,
        resetComponentFilterField: component.resetComponentFilterField,
        assetsHealthFilterFieldData: component.assetsHealthFilterFieldData,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
          loadComponentsByPage,
          loadAssetTypes,
      },
      dispatch
    );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ComponentFilter)
);
